import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteFolder = () => {
  const { mutate: deleteFolder, isPending } = useAppMutation([QueryKey.DELETE_FOLDER], {
    mutationFn: ({ companyId, folderId }: { companyId: string; folderId: string }) =>
      ApiService.delete({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'vault', 'folders', folderId],
      }),
  });
  return { deleteFolder, isPending };
};
